import {
    CREATE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST,
    CREATE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS,
    CREATE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE,
    DELETE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST,
    DELETE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS,
    DELETE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE,
    FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST,
    FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS,
    FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE,
    FETCH_STYLE_PREPARATION_SELECTED_STYLES_REQUEST,
    FETCH_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS,
    FETCH_STYLE_PREPARATION_SELECTED_STYLES_FAILURE,
    UPDATE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST,
    UPDATE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS,
    UPDATE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE,
    RESET_STYLE_PREPARATION_SELECTED_STYLES_INFO,
    CREATE_STYLE_PREPARATION_SELECTED_STYLES_FORM,
    UPDATE_STYLE_PREPARATION_SELECTED_STYLES_FORM,
    FETCH_STYLE_PREPARATION_INVOICE_REQUEST,
    FETCH_STYLE_PREPARATION_INVOICE_SUCCESS,
    FETCH_STYLE_PREPARATION_INVOICE_FAILURE,
    RESET_STYLE_PREPARATION_INVOICE,
    STYLE_PREPARATION_TAB_ACTIVATION_KEYS
} from './stylePreparation.actionsType';

export const STYLE_PREPARATION = 'stylePreparations';

let initialState = {
    loading: false,
    stylePreparations: [],
    selectedStyleDetailsList: [],
    stylePreparationsForm: {},
    addSelectedStyleResponseStatus: '',
    selectedState: {},
    errorMessage: '',
    stylePrepInvoice: [],
    activeKey: null

};

export let stylePreparationsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STYLE_PREPARATION_SELECTED_STYLES_REQUEST:
        case CREATE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST:
        case UPDATE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST:
        case FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST:
        case DELETE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST:
        case FETCH_STYLE_PREPARATION_INVOICE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedStyleDetailsList: updatePayload
            };
        case STYLE_PREPARATION_TAB_ACTIVATION_KEYS:
            return {
                ...state,
                loading: false,
                activeKey: payload
            }
        case CREATE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreparationsForm: {},
                addSelectedStyleResponseStatus: updatePayload?.status
            };
        case UPDATE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreparationsForm: {}
            };
        case FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreparationsForm: updatePayload
            };
        case DELETE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreparationsForm: {}
            };
        case FETCH_STYLE_PREPARATION_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePrepInvoice: updatePayload
            };
        case RESET_STYLE_PREPARATION_INVOICE:
            return {
                ...state,
                stylePrepInvoice: []
            };
        case RESET_STYLE_PREPARATION_SELECTED_STYLES_INFO:
            return {
                ...state,
                stylePreparationsForm: {}
            };
        case CREATE_STYLE_PREPARATION_SELECTED_STYLES_FORM:
        case UPDATE_STYLE_PREPARATION_SELECTED_STYLES_FORM:
            return {
                ...state,
                loading: false,
                stylePreparationsForm: {
                    ...state.stylePreparationsForm,
                    [payload.key]: payload.value
                }
            };
        case CREATE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE:
            return {
                ...state,
                loading: false,
                addSelectedStyleResponseStatus: updatePayload?.status
            };
        case FETCH_STYLE_PREPARATION_SELECTED_STYLES_FAILURE:
        case UPDATE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE:
        case FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE:
        case DELETE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE:
        case FETCH_STYLE_PREPARATION_INVOICE_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};


